import { useCallback, useState } from 'react';

import type { ErrorLike } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import { gql } from '@graphql/__generated__';

const GET_CMA_REPORT_FOR_PREVIEW = gql(/* GraphQL */ `
  query GetCmaReportForPreview($id: uuid!) {
    cma_reports_by_pk(id: $id) {
      ...CMAReportEditor
      ...CmaReportInclude
      report_source
      broker {
        show_in_agency_pages
        default_team {
          show_in_agency_pages
        }
      }
      __typename
    }
  }
`);

export const useCmaPreview = () => {
  const [cmaPreviewId, setCmaPreviewId] = useState<string | null>(null);
  const [apolloError, setErrorLike] = useState<ErrorLike | null>(null);

  const { data, loading } = useQuery(GET_CMA_REPORT_FOR_PREVIEW, {
    variables: { id: cmaPreviewId ?? '' },
    skip: cmaPreviewId == null,
    fetchPolicy: 'network-only',
  });

  const cmaReport = data?.cma_reports_by_pk;
  const isPreviewOpen = cmaPreviewId != null;

  const openPreview = useCallback((reportId: string) => {
    setCmaPreviewId(reportId);
  }, []);

  const closePreview = useCallback(() => {
    setCmaPreviewId(null);
    setErrorLike(null);
  }, []);

  const clearError = useCallback(() => {
    setErrorLike(null);
  }, []);

  return {
    cmaReport,
    isPreviewOpen,
    isLoading: loading,
    apolloError,
    openPreview,
    closePreview,
    clearError,
  };
};
